// Filters Component
// Handles staff view filter controls (waiting/standby)

import { FILTER_TYPES } from '../config/constants.js';
import stateManager from '../core/state-manager.js';

/**
 * Initialize filter controls
 *
 * @param {function} onFilterChange - Callback when filter changes
 */
export function initFilters(onFilterChange) {
    const waitingFilter = document.getElementById('filter-waiting');
    const standbyFilter = document.getElementById('filter-standby');

    waitingFilter.addEventListener('click', () => {
        stateManager.setListFilter(FILTER_TYPES.WAITING);
        updateFilterStyles();

        if (onFilterChange) {
            onFilterChange(FILTER_TYPES.WAITING);
        }
    });

    standbyFilter.addEventListener('click', () => {
        stateManager.setListFilter(FILTER_TYPES.STANDBY);
        updateFilterStyles();

        if (onFilterChange) {
            onFilterChange(FILTER_TYPES.STANDBY);
        }
    });

    // Initial style update
    updateFilterStyles();
}

/**
 * Update filter button styles based on current filter
 */
export function updateFilterStyles() {
    const waitingFilter = document.getElementById('filter-waiting');
    const standbyFilter = document.getElementById('filter-standby');
    const currentFilter = stateManager.getState('listFilter');

    if (currentFilter === FILTER_TYPES.WAITING) {
        waitingFilter.classList.add('border-[var(--color-primary)]');
        waitingFilter.classList.remove('border-transparent');
        standbyFilter.classList.remove('border-[var(--color-primary)]');
        standbyFilter.classList.add('border-transparent');
    } else {
        standbyFilter.classList.add('border-[var(--color-primary)]');
        standbyFilter.classList.remove('border-transparent');
        waitingFilter.classList.remove('border-[var(--color-primary)]');
        waitingFilter.classList.add('border-transparent');
    }
}

/**
 * Update queue count displays
 *
 * @param {object} counts - Queue counts { waiting, standby, totalWaiting }
 */
export function updateQueueCounts(counts) {
    document.getElementById('staff-queue-count').textContent = counts.waiting;
    document.getElementById('staff-standby-count').textContent = counts.standby;
}
